import React from 'react'
import logger from '../../../utils/logger'
import './customInput2.css'


export const CustomInput2 = ({ register, name, type, placeholder, className, value, resetField, disabled = false }) => {


  return (
    <div className="form-floating form-aSearch">
      <input
        {...register(`${name}`)}
        id={name}
        type={type}
        className={`form-control input-height ${className}`}
        // className="form-control input-height"
        placeholder={placeholder}
        autoComplete={name}
        disabled={disabled}
      />

      <label className="label-fButtons" htmlFor={name}>{placeholder}</label>

      {value?.[name] && (
        <button
          type="button"
          className="clear-icon"
          onMouseDown={e => e.preventDefault()}
          onClick={resetField}
          aria-label="Limpiar"
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 20 20"
            aria-hidden="true"
            role="none"
          >
            <path
              d="M14 6l-8 8M6 6l8 8"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
      )}

    </div>
  )
}

